import Quill from 'quill';

export const sanitize = () => 
{
    var Link = Quill.import('formats/link');
    var builtInFunc = Link.sanitize;
    Link.sanitize = function customSanitizeLinkInput(linkValueInput) {
    var val = linkValueInput;

    // do nothing, since this implies user's already using a custom protocol
    if (/^\w+:/.test(val)) return linkValueInput;
    else if (!/^https?:/.test(val))
        val = "http://google.com/search?q=" + val;

    return builtInFunc.call(this, val); // retain the built-in logic
    };
}